import { render, staticRenderFns } from "./vsTabs.vue?vue&type=template&id=6ff35123&lang=html&"
import script from "./vsTabs.vue?vue&type=script&lang=js&"
export * from "./vsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsTabs.vue"
export default component.exports